import FeaturesList from "@/components/Features/components/FeaturesList/FeaturesList";
import Section from "@/components/Section";
import { Box, Typography } from "@mui/material";

const FeaturesSlider = () => {
  return (
    <Section pt={{ xs: 0, md: 4.5, lg: 9 }} pb={10}>
      <Box
        mb={{ xs: 5, md: 8, lg: 16 }}
        display={{ xs: "block", lg: "flex" }}
        justifyContent="space-between"
        alignItems="flex-end"
        gap={{ xs: 2, md: 3, lg: 10, xl: 30 }}
        textAlign={{ xs: "start", sm: "center", lg: "start" }}
      >
        <Typography
          variant="h2"
          mb={{ xs: 2, md: 0 }}
          minWidth={{ md: 600 }}
          maxWidth={{ xs: "auto", xl: 700 }}
        >
          One management platform, endless telematic features.One Platform. Endless Features.
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          Remote viewing and control, alerts, reports, compliance, third-party integration — all your GPS vehicle tracking and management needs in one place.
        </Typography>
      </Box>
      <FeaturesList />
    </Section>
  );
};

export default FeaturesSlider;
